import { LangDisplay, StoreDisplay } from '../types';
import { LANG } from '../config';
import { ChangeEvent, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { StoresContext } from '../App';

export function debounce(func: Function, timeout = 300) {
    let timer: NodeJS.Timeout;
    return (...args: any[]) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            // @ts-ignore
            func.apply(this, args);
        }, timeout);
    };
}

export function getLangVar(s: StoreDisplay, key: keyof LangDisplay) {
    return s.langs[LANG]?.[key] || s.langs['ru']?.[key] || null;
}

const locale = {
    ru: {
        address: 'Адрес',
        district: 'Федеральный округ',
        phone: 'Телефон',
        email: 'Email',
        stock: 'В наличии',
        workHours: 'Время работы',
        website: 'Сайт',
        deliveryDays: 'Дни доставки',
        deliveryComment: 'Примечание к доставке',
    },
};

export const getStoreBalloonOptions = (s: StoreDisplay) => {
    const phone = getLangVar(s, 'phone');
    const email = getLangVar(s, 'email');
    const values = {
        address: getLangVar(s, 'address') || '',
        district: s.federalDistrict,
        workHours: getLangVar(s, 'workHours') || '',
        phone: (phone && `<a href='tel:${phone}'>${phone}</a>`) || '',
        email: (email && `<a href='mailto:${email}'>${email}</a>`) || '',
        website: s.url && `<a href='${s.url}'>${s.url}</a>`,
        stock: !!s.product?.stock && 'да',
        deliveryDays: !!s.product?.stock && s.product?.deliveryDays,
        deliveryComment: !!s.product?.stock && s.product?.comment,
    };
    const rows = Object.entries(values)
        .filter(([_, v]) => v)
        .map(
            ([k, v]) => `
            <div class='map-popup-text'>
              <span>${locale[LANG]?.[k as keyof typeof values] || 'missing label'}: </span>${v}
            </div>
        `
        );
    return `
<div style='overflow: scroll;'>
   <div class='map-popup-desc'>
        <div class='map-popup-cap'>
          <strong>${getLangVar(s, 'name')}</strong>
        </div>
        ${rows.join('')}   
   </div>     
</div>
`;
};

export function useOutsideClick() {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (isOpen) {
            const callback = (e: MouseEvent) => {
                if (!dropdownRef.current?.contains(e.target as Node)) {
                    setIsOpen(false);
                }
            };
            window.addEventListener('click', callback);
            return () => window.removeEventListener('click', callback);
        }
    }, [isOpen]);
    return { isOpen, setIsOpen, dropdownRef };
}

export function useDebouncedSearch() {
    const { setSearch } = useContext(StoresContext);
    return useMemo(
        () =>
            debounce((e: ChangeEvent<HTMLInputElement>) => {
                setSearch(e.target.value.trim().toLowerCase());
            }),
        [setSearch]
    );
}
